<div class="header">
  <h1>{{ title }}</h1> <app-hint-icon *ngIf="tooltipText" [tooltipText]="tooltipText"></app-hint-icon>
</div>

<nz-divider></nz-divider>
